import { Injectable } from '@angular/core';
import { AuthserviceService } from './authservice.service';
import * as xml2js from 'xml2js';
import { SubscriptionService } from './subscription.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class MsisdnService {

  constructor(
    private authserviceService: AuthserviceService,
    private subscriptionService: SubscriptionService,
    private _router: Router,) { }
  xml: string;

  strResponse: any;

  async fetchMSISDN() {
    let msisdn;
    let wifiModalBox = false;
    this.authserviceService.fetchMobileNumber()
      .then((response) => {
        //  console.log('success response ======================', response);

        const parser = new xml2js.Parser({ strict: false, trim: true });
        // console.log('XML =======================', this.strResponse);
        parser.parseString(response, (err, result) => {
          this.xml = result;

          if (this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:RESPONSEHEADER'][0]['NS0:RESPONSECODE'][0] == 0) {
            msisdn = this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:BODY'][0]['NS1:MSISDNRESPONSE'][0]['NS1:MSISDNHASH'][0];

            localStorage.setItem('msisdn', msisdn);
            // this.subscriptionService.checkSubscription();
          }
        });
      })
      .catch((error) => {
        this.strResponse = error;
        //localStorage.setItem('msisdn', '719767789677');
      });
  }


}



